/* Pendant Placement Studio — extracted from section for cacheable HTML */
(function (global) {
  function initPendantStudio(root, cfg) {
    if (!root || root.dataset.ppsReady) return;
    root.dataset.ppsReady = '1';
    const ROOT = root;
    const CFG = cfg;
    const SID = ROOT.id.replace(/^pps-/, '');
    const $ = (s) => ROOT.querySelector(s),
      $$ = (s) => [...ROOT.querySelectorAll(s)];
    const fmt = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      maximumFractionDigits: 0
    });
    // Brands to surface first in the grid (top of list = shown first). Partial, case-insensitive match on vendor.
    const PRIORITY = (CFG.priorityBrands || '')
      .split(/[\n,]+/)
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);
    function brandRank(v) {
      const vl = (v || '').toLowerCase();
      for (let i = 0; i < PRIORITY.length; i++) {
        if (vl.indexOf(PRIORITY[i]) > -1) return i;
      }
      return 999;
    }

    /* ---------- DATA ---------- */
    const ROOMS = {
      island: {
        label: 'Kitchen Island',
        icon: 'island',
        mode: 'surface',
        surfaceLabel: 'Island length',
        surfaceHeight: 900,
        hang: [750, 900],
        min: 1000,
        max: 4500,
        def: 2400,
        roomTag: 'Room_Kitchen',
        blurb: 'Task light over the bench — usually a row of 2 or 3.',
        tip: 'Measure the full length of your benchtop, end to end.'
      },
      dining: {
        label: 'Dining Table',
        icon: 'dining',
        mode: 'surface',
        surfaceLabel: 'Table length',
        surfaceHeight: 750,
        hang: [750, 900],
        min: 900,
        max: 3600,
        def: 1800,
        roomTag: 'Room_Dining',
        blurb: 'Centre over the table — a statement single or a balanced set.',
        tip: 'Measure along the longest edge of your table.'
      },
      bedside: {
        label: 'Bedside',
        icon: 'bed',
        mode: 'bedside',
        surfaceLabel: 'Nightstand width',
        surfaceHeight: 600,
        hang: [500, 700],
        min: 300,
        max: 700,
        def: 450,
        roomTag: 'Room_Bedroom',
        blurb: 'A pendant each side, in place of table lamps.',
        tip: 'One pendant centred over each nightstand.'
      },
      stair: {
        label: 'Stair Void / High Ceiling',
        icon: 'stair',
        mode: 'feature',
        clearance: 2100,
        surfaceLabel: 'Void / stairwell width',
        min: 1000,
        max: 6000,
        def: 2500,
        roomTag: 'Room_Stairway',
        blurb: 'A long-drop feature or cascading cluster.',
        tip: 'The lowest pendant must clear the highest tread by 2100mm+.'
      },
      entry: {
        label: 'Entry / Hallway',
        icon: 'door',
        mode: 'feature',
        clearance: 2100,
        surfaceLabel: 'Entry / hallway width',
        min: 800,
        max: 4000,
        def: 1500,
        roomTag: 'Room_Entry',
        blurb: 'A welcoming first impression with safe headroom.',
        tip: 'Keep the bottom of the fitting 2100mm+ off the floor; mind door swings.'
      },
      living: {
        label: 'Living Room',
        icon: 'sofa',
        mode: 'feature',
        clearance: 1800,
        surfaceLabel: 'Seating area width',
        min: 1500,
        max: 8000,
        def: 4000,
        roomTag: 'Room_Living',
        blurb: 'Layered, ambient — often lower over a coffee table.',
        tip: 'Over a coffee table you can hang lower as a focal point.'
      },
      commercial: {
        label: 'Commercial / Cafe',
        icon: 'cup',
        mode: 'surface',
        surfaceLabel: 'Counter / bar length',
        surfaceHeight: 1050,
        hang: [700, 900],
        min: 1200,
        max: 6000,
        def: 3000,
        roomTag: 'Room_Dining',
        blurb: 'Repeatable rhythm over counters and communal tables.',
        tip: 'Respect egress and clearance over walkways (2100mm+).'
      },
      bathroom: {
        label: 'Bathroom',
        icon: 'bath',
        mode: 'surface',
        surfaceLabel: 'Vanity / bath length',
        surfaceHeight: 900,
        hang: [600, 900],
        min: 600,
        max: 2400,
        def: 1200,
        roomTag: 'Room_Bathroom',
        blurb: 'Over a vanity or freestanding bath — IP-rated fittings only.',
        tip: 'Bathrooms have wet-area IP zones (AS/NZS 3000) — use IP44+ rated pendants. Keep clear of the bath/shower zone.'
      }
    };
    // Room is matched on the Filter:Room metafield (many products have the metafield but NOT a Room_ tag). Lowercased for comparison.
    const ROOM_MF = {
      island: ['kitchen island', 'kitchen'],
      dining: ['dining table', 'dining room'],
      bedside: ['bedroom / bedside', 'bedroom'],
      bathroom: ['bathroom'],
      stair: ['stair void / high ceiling'],
      entry: ['entry / hallway', 'hallway'],
      living: ['living room', 'lounge room'],
      commercial: ['commercial', 'cafe', 'hospitality']
    };
    const ICONS = {
      island:
        '<rect x="8" y="26" width="32" height="10" rx="2"/><line x1="16" y1="6" x2="16" y2="20"/><circle cx="16" cy="22" r="4"/><line x1="32" y1="6" x2="32" y2="20"/><circle cx="32" cy="22" r="4"/>',
      dining:
        '<line x1="24" y1="6" x2="24" y2="18"/><path d="M14 24 a10 6 0 0 0 20 0z"/><rect x="10" y="32" width="28" height="4" rx="2"/>',
      bed: '<path d="M8 30 v-8 a4 4 0 0 1 4-4 h24 a4 4 0 0 1 4 4 v8"/><line x1="6" y1="30" x2="42" y2="30"/><line x1="14" y1="8" x2="14" y2="16"/><circle cx="14" cy="18" r="3"/>',
      stair:
        '<path d="M8 38 v-6 h8 v-6 h8 v-6 h8 v-6 h8"/><line x1="22" y1="6" x2="22" y2="16"/><circle cx="22" cy="19" r="3"/>',
      door: '<rect x="14" y="8" width="20" height="32" rx="1"/><circle cx="29" cy="24" r="1.6"/><line x1="24" y1="2" x2="24" y2="8"/>',
      sofa: '<path d="M8 30 v-6 a3 3 0 0 1 3-3 h26 a3 3 0 0 1 3 3 v6"/><rect x="6" y="30" width="36" height="8" rx="3"/><line x1="14" y1="21" x2="34" y2="21"/>',
      cup: '<path d="M12 16 h20 v10 a8 8 0 0 1-8 8 h-4 a8 8 0 0 1-8-8z"/><path d="M32 18 h4 a3 3 0 0 1 0 8 h-4"/><line x1="18" y1="6" x2="18" y2="12"/><line x1="26" y1="6" x2="26" y2="12"/>',
      bath: '<path d="M6 24 h36 v5 a7 7 0 0 1-7 7 H13 a7 7 0 0 1-7-7z"/><path d="M11 24 v-9 a3.5 3.5 0 0 1 7 0"/><line x1="11" y1="40" x2="14" y2="36"/><line x1="37" y1="40" x2="34" y2="36"/>'
    };
    // Type = tag-based (server-side). Style/Colour/Material = metafield-based (client-side); values exactly match the Filter:* metafield options.
    const TYPEF = {
      label: 'Type',
      opts: [
        ['Single', '__single'],
        ['Linear', 'Size_Linear'],
        ['Cluster', 'Size_Multiple']
      ]
    };
    const MF = {
      style: {
        label: 'Style',
        mf: 'mfStyle',
        opts: [
          'Modern',
          'Contemporary',
          'Coastal',
          'Hamptons',
          'Industrial',
          'Scandinavian',
          'Crystal',
          'Art Deco',
          'Traditional',
          'French Provincial',
          'Tiffany',
          'Glass',
          'Architectural',
          'Federation',
          'Minimalistic',
          'Wabi-Sabi'
        ]
      },
      colour: {
        label: 'Colour',
        mf: 'mfColour',
        opts: [
          'Beige',
          'Black',
          'Brass',
          'Bronze',
          'Brown',
          'Chrome',
          'Clear/Glass',
          'Copper',
          'Gold',
          'Grey',
          'Red',
          'Silver',
          'Travertine',
          'White',
          'Wood Tone'
        ]
      },
      material: {
        label: 'Material',
        mf: 'mfMaterial',
        opts: [
          'Glass',
          'Metal',
          'Brass',
          'Copper',
          'Crystal',
          'Ceramic',
          'Fabric',
          'Rattan',
          'Concrete',
          'Aluminium',
          'Marble',
          'Stone',
          'Travertine',
          'Wood Finish',
          'Acrylic',
          'Bamboo',
          'Plaster',
          'Plastic ABS',
          'Terrazzo',
          '304 Stainless Steel',
          '316 Stainless Steel',
          'Paper/ Cardboard'
        ]
      }
    };
    const QUIZ = [
      {
        key: 'room',
        q: 'Where is it going?',
        count: 'Question 1 of 5',
        opts: [
          ['Kitchen Island', 'island', 'Over the bench'],
          ['Dining Table', 'dining', 'Centre of the room'],
          ['Bedside', 'bedside', 'Beside the bed'],
          ['Bathroom', 'bathroom', 'Vanity or bath'],
          ['Stair / Void', 'stair', 'High ceiling'],
          ['Entry / Hall', 'entry', 'First impression'],
          ['Living', 'living', 'Lounge & relax']
        ]
      },
      {
        key: 'style',
        q: "What's the look?",
        count: 'Question 2 of 5',
        opts: [
          ['Modern', 'Modern', 'Clean & minimal'],
          ['Coastal', 'Coastal', 'Light & breezy'],
          ['Hamptons', 'Hamptons', 'Relaxed luxe'],
          ['Industrial', 'Industrial', 'Raw & moody'],
          ['Scandinavian', 'Scandinavian', 'Warm & simple'],
          ['Classic', 'Traditional', 'Elegant & timeless']
        ]
      },
      {
        key: 'colour',
        q: 'Finish or colour?',
        count: 'Question 3 of 5',
        opts: [
          ['Matte Black', 'Black', 'Bold & graphic'],
          ['White', 'White', 'Clean & soft'],
          ['Brass', 'Brass', 'Warm metal'],
          ['Chrome', 'Chrome', 'Cool & crisp'],
          ['Timber', 'Wood Tone', 'Organic tone'],
          ['Any', '', 'Show me all']
        ]
      },
      {
        key: 'material',
        q: 'Shade or material?',
        count: 'Question 4 of 5',
        opts: [
          ['Glass', 'Glass', 'Smoked or clear'],
          ['Metal', 'Metal', 'Open & airy'],
          ['Rattan', 'Rattan', 'Woven texture'],
          ['Concrete', 'Concrete', 'Architectural'],
          ['Fabric', 'Fabric', 'Soft diffusion'],
          ['Any', '', 'Show me all']
        ]
      },
      {
        key: 'config',
        q: 'How many?',
        count: 'Question 5 of 5',
        opts: [
          ['Single', 'single', 'One statement'],
          ['Set of 2–3', 'set', 'A balanced row'],
          ['Cluster', 'cluster', 'Staggered group'],
          ['Linear', 'linear', 'One long fitting']
        ]
      }
    ];
    const FAQS = [
      [
        'How high should I hang a pendant over a kitchen island?',
        'Hang the bottom of the fitting 750–900mm above the benchtop. That keeps clear sightlines across the bench while putting good task light where you prep. Around 800–850mm is the sweet spot for most ceilings.'
      ],
      [
        'What size pendant do I need over a dining table?',
        'Aim for a total fitting width of about half to two-thirds of the table width. For a 2.4m table that means 1200–1600mm of fitting — whether that is one wide piece, a linear, or a row of pendants.'
      ],
      [
        'How many pendants should I hang over my island?',
        'Under 2m: two pendants. 2–3m: two or three. Over 3m: three or more, or a single linear pendant. Divide the island into equal parts and centre a light in each.'
      ],
      [
        'How far apart should pendant lights be?',
        'Space them evenly by dividing the island length by the number of pendants, then centre each light in its section — typically around 600–760mm centre to centre. Keep the end lights 150–300mm in from the island ends.'
      ],
      [
        'How high above a dining table should a pendant hang?',
        '750–900mm from the tabletop to the bottom of the fitting. Hang toward the lower end for a cosier, more intimate feel over the table.'
      ],
      [
        'When should I choose a linear pendant instead of separate pendants?',
        'Linear pendants suit long, narrow islands and rectangular tables — one elegant fitting gives an even wash of light without the busyness of several separate pendants.'
      ],
      [
        'How do I light a stairwell or void?',
        'Treat it as a feature. Keep the lowest pendant at least 2100mm above the highest tread or landing, and use a long single drop or a cascading cluster — fixture length around 20–25% of the void height.'
      ],
      [
        'How high should bedside pendants hang?',
        'Around 500–700mm above the nightstand surface, used in place of a table lamp. Hang one each side of the bed and keep the diameter modest so it does not crowd the space.'
      ],
      [
        'Does my ceiling height change the height?',
        'The height above the surface stays the same — what grows is the drop. Add roughly 75mm of drop for every 300mm of ceiling above 2.4m so the proportion still reads well.'
      ]
    ];

    /* ---------- STATE ---------- */
    const state = {
      room: 'island',
      surfaceLength: 2400,
      ceiling: 2700,
      config: 'auto',
      roomL: 4.5,
      roomW: 4.0
    };
    const shopState = {
      room: 'island',
      type: '',
      style: '',
      colour: '',
      material: '',
      matchSize: false,
      band: null,
      maxHeight: null
    };
    const cfgToType = (c) =>
      c === 'linear'
        ? 'Size_Linear'
        : c === 'cluster'
          ? 'Size_Multiple'
          : c === 'single'
            ? '__single'
            : '';
    let lastOut = null;

    /* ---------- ROOM CARDS + CALC ROOM SEG ---------- */
    const roomGrid = $('[data-roomgrid]'),
      calcRooms = $('[data-calcrooms]');
    Object.entries(ROOMS).forEach(([k, r]) => {
      const c = document.createElement('button');
      c.className = 'room-card';
      c.dataset.room = k;
      c.innerHTML =
        '<svg class="ico" viewBox="0 0 48 44" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        ICONS[r.icon] +
        '</svg><h3>' +
        r.label +
        '</h3><p>' +
        r.blurb +
        '</p><span class="go">explore</span>';
      c.addEventListener('click', () => {
        selectRoom(k);
        $('#pps-calc-' + SID).scrollIntoView({ behavior: 'smooth' });
      });
      roomGrid.appendChild(c);
      const s = document.createElement('button');
      s.dataset.room = k;
      s.textContent = r.label.replace(' / High Ceiling', '').replace('Commercial / Cafe', 'Cafe');
      s.addEventListener('click', () => selectRoom(k));
      calcRooms.appendChild(s);
    });

    /* ---------- CONTROLS ---------- */
    const surfaceLen = $('[data-surfacelen]'),
      ceiling = $('[data-ceiling]'),
      roomL = $('[data-rooml]'),
      roomW = $('[data-roomw]');
    surfaceLen.addEventListener('input', () => {
      state.surfaceLength = +surfaceLen.value;
      $('[data-surfacelenv]').textContent = surfaceLen.value;
      render();
    });
    ceiling.addEventListener('input', () => {
      state.ceiling = +ceiling.value;
      $('[data-ceilingv]').textContent = ceiling.value;
      render();
    });
    roomL.addEventListener('input', () => {
      state.roomL = +roomL.value;
      $('[data-roomlv]').textContent = (+roomL.value).toFixed(1);
      render();
    });
    roomW.addEventListener('input', () => {
      state.roomW = +roomW.value;
      $('[data-roomwv]').textContent = (+roomW.value).toFixed(1);
      render();
    });
    $$('[data-calcconfig] button').forEach((b) =>
      b.addEventListener('click', () => {
        $$('[data-calcconfig] button').forEach((x) => x.classList.remove('on'));
        b.classList.add('on');
        state.config = b.dataset.cfg;
        render();
      })
    );

    function selectRoom(k) {
      state.room = k;
      const r = ROOMS[k];
      $$('.room-card').forEach((c) => c.classList.toggle('active', c.dataset.room === k));
      $$('[data-calcrooms] button').forEach((c) => c.classList.toggle('on', c.dataset.room === k));
      $('[data-fieldsurface]').style.display = '';
      $('[data-fieldroomdims]').style.display = 'none';
      $('[data-surfacelabel]').textContent = r.surfaceLabel;
      surfaceLen.min = r.min;
      surfaceLen.max = r.max;
      state.surfaceLength = r.def;
      surfaceLen.value = r.def;
      $('[data-surfacelenv]').textContent = r.def;
      $('[data-calctip]').textContent = r.tip;
      $('[data-guidectx]').textContent =
        'Showing guidance for ' +
        r.label.toLowerCase() +
        '. Change the room above and these update.';
      render();
    }

    /* ---------- COMPUTE ---------- */
    function compute() {
      const r = ROOMS[state.room],
        o = { notes: [] };
      if (r.mode === 'surface') {
        const L = state.surfaceLength;
        o.widthMin = Math.round(L * 0.5);
        o.widthMax = Math.round(L * (2 / 3));
        let N,
          cfg = state.config;
        if (cfg === 'linear') {
          N = 1;
          o.linear = true;
        } else if (cfg === 'single') {
          N = 1;
        } else if (cfg === 'cluster') {
          N = 3;
          o.cluster = true;
        } else {
          if (state.room === 'dining') N = L < 1400 ? 1 : L <= 2400 ? 2 : 3;
          else N = L < 2000 ? 2 : L < 2400 ? 2 : L <= 3000 ? 3 : Math.max(3, Math.ceil(L / 1100));
          if (cfg === 'set' && N < 2) N = 2;
        }
        o.count = N;
        o.spacing = Math.round(L / N);
        o.endOffset = Math.round(L / (2 * N));
        if (!o.linear) {
          let e = Math.round(L / (N * 2.4) / 10) * 10;
          e = Math.min(450, Math.max(200, e));
          o.eachDiameter = e;
        }
        o.positions = [];
        for (let i = 0; i < N; i++) o.positions.push(Math.round(((i + 0.5) * L) / N));
        o.hang = r.hang;
        o.hangMid = Math.round((r.hang[0] + r.hang[1]) / 2);
        o.surfaceHeight = r.surfaceHeight;
        o.dropFromCeiling = Math.max(0, state.ceiling - (r.surfaceHeight + o.hangMid));
        // size band for product matching: one fitting spans the surface (linear/single),
        // but a ROW of pendants matches each pendant's own diameter, not the whole span.
        if (o.linear || o.count === 1) {
          o.band = [o.widthMin, o.widthMax];
        } else {
          o.band = [Math.round(o.eachDiameter * 0.7), Math.round(o.eachDiameter * 1.3)];
        }
        o.maxHeight = Math.max(200, state.ceiling - (r.surfaceHeight + o.hang[0]));
      } else if (r.mode === 'bedside') {
        o.count = 1;
        o.eachDiameter = Math.min(
          320,
          Math.max(180, Math.round((state.surfaceLength * 0.55) / 10) * 10 || 220)
        );
        o.hang = [500, 700];
        o.hangMid = 600;
        o.surfaceHeight = 600;
        o.positions = [Math.round(state.surfaceLength / 2)];
        o.notes.push('Hang one pendant on each side of the bed.');
        o.dropFromCeiling = Math.max(0, state.ceiling - 1200);
        o.band = [Math.round(o.eachDiameter * 0.7), Math.round(o.eachDiameter * 1.3)];
        o.maxHeight = Math.max(200, state.ceiling - 1100);
      } else {
        const W = state.surfaceLength;
        o.feature = true;
        o.featureDiameter = Math.min(1600, Math.max(250, Math.round((W * 0.3) / 10) * 10));
        o.clearance = r.clearance;
        o.dropFromCeiling = Math.max(0, state.ceiling - r.clearance);
        o.voidLen = Math.round((state.ceiling * 0.22) / 10) * 10;
        o.count = state.config === 'cluster' ? 3 : 1;
        if (o.count > 1) o.cluster = true;
        if (state.room === 'stair')
          o.notes.push('Keep the lowest pendant 2100mm+ above the highest tread.');
        o.band = [Math.round(W * 0.22), Math.round(W * 0.42)];
        o.maxHeight = Math.max(300, state.ceiling - r.clearance);
      }
      o.roomTag = r.roomTag;
      return o;
    }

    /* ---------- RESULTS ---------- */
    function renderResults(o) {
      const c = [];
      if (o.feature) {
        c.push([
          'Pendant size',
          o.cluster ? 'Cluster of 3' : o.featureDiameter + '<small> mm Ø</small>'
        ]);
        c.push(['Arrangement', o.cluster ? 'Staggered cluster' : 'Single feature']);
        c.push(['Min. clearance', o.clearance + '<small> mm</small>']);
        c.push(['Drop from ceiling', o.dropFromCeiling + '<small> mm</small>']);
      } else if (o.linear) {
        c.push(['Fitting width', o.widthMin + '–' + o.widthMax + '<small> mm</small>']);
        c.push(['Pendants', '1<small> linear</small>']);
        c.push(['Hang above top', o.hang[0] + '–' + o.hang[1] + '<small> mm</small>']);
        c.push(['Drop from ceiling', o.dropFromCeiling + '<small> mm</small>']);
      } else {
        c.push([
          'Fitting span',
          o.widthMin
            ? o.widthMin + '–' + o.widthMax + '<small> mm</small>'
            : o.eachDiameter + '<small> mm Ø</small>'
        ]);
        c.push([
          'Pendants',
          o.count +
            (o.count > 1
              ? '<small> · ' + o.spacing + 'mm apart</small>'
              : o.eachDiameter
                ? '<small> · ' + o.eachDiameter + 'mm Ø</small>'
                : '')
        ]);
        c.push(['Hang height', o.hang[0] + '–' + o.hang[1] + '<small> mm</small>']);
        c.push(['Drop from ceiling', o.dropFromCeiling + '<small> mm</small>']);
      }
      $('[data-results]').innerHTML = c
        .map(
          (x) =>
            '<div class="res"><div class="k">' +
            x[0] +
            '</div><div class="v">' +
            x[1] +
            '</div></div>'
        )
        .join('');
      $('[data-resultnote]').textContent = o.notes[0] || '';
    }

    /* ---------- SVG VISUALISER ---------- */
    const NS = 'http://www.w3.org/2000/svg';
    function el(t, a) {
      const e = document.createElementNS(NS, t);
      for (const k in a) e.setAttribute(k, a[k]);
      return e;
    }
    function txt(g, x, y, fill, size, anchor, s) {
      const t = el('text', {
        x,
        y,
        fill,
        'font-size': size,
        'font-family': 'Inter,sans-serif',
        'text-anchor': anchor || 'start'
      });
      t.textContent = s;
      g.appendChild(t);
    }
    function pendant(g, x, topY, bottomY, d, sway, delay) {
      const grp = el('g', { class: 'sway ' + sway, style: 'animation-delay:' + delay + 's' });
      grp.appendChild(
        el('line', {
          x1: x,
          y1: topY,
          x2: x,
          y2: bottomY - 14,
          stroke: '#6f6049',
          'stroke-width': 1.4
        })
      );
      const w = Math.max(16, Math.min(46, d / 9));
      grp.appendChild(
        el('path', {
          d:
            'M' +
            (x - w) +
            ' ' +
            bottomY +
            ' L' +
            (x - w * 0.5) +
            ' ' +
            (bottomY - 16) +
            ' L' +
            (x + w * 0.5) +
            ' ' +
            (bottomY - 16) +
            ' L' +
            (x + w) +
            ' ' +
            bottomY +
            ' Z',
          fill: 'url(#' + ('pps-shade-' + SID) + ')',
          stroke: '#3a2f1f',
          'stroke-width': 1
        })
      );
      grp.appendChild(
        el('circle', {
          cx: x,
          cy: bottomY + 2,
          r: 7,
          fill: 'url(#' + ('pps-bulb-' + SID) + ')',
          class: 'flicker'
        })
      );
      grp.appendChild(
        el('path', {
          d:
            'M' +
            (x - w * 0.6) +
            ' ' +
            bottomY +
            ' L' +
            (x - w * 2.1) +
            ' ' +
            (bottomY + 150) +
            ' L' +
            (x + w * 2.1) +
            ' ' +
            (bottomY + 150) +
            ' L' +
            (x + w * 0.6) +
            ' ' +
            bottomY +
            ' Z',
          fill: 'url(#' + ('pps-cone-' + SID) + ')',
          opacity: 0.5
        })
      );
      g.appendChild(grp);
    }
    function dim(g, x1, y1, x2, y2, label, side) {
      const c = '#9b8a6c';
      g.appendChild(
        el('line', { x1, y1, x2, y2, stroke: c, 'stroke-width': 1, 'stroke-dasharray': '1 3' })
      );
      if (x1 === x2) {
        g.appendChild(el('line', { x1: x1 - 4, y1, x2: x1 + 4, y2: y1, stroke: c }));
        g.appendChild(el('line', { x1: x2 - 4, y1: y2, x2: x2 + 4, y2: y2, stroke: c }));
      } else {
        g.appendChild(el('line', { x1, y1: y1 - 4, x2: x1, y2: y1 + 4, stroke: c }));
        g.appendChild(el('line', { x1: x2, y1: y2 - 4, x2: x2, y2: y2 + 4, stroke: c }));
      }
      const mx = (x1 + x2) / 2,
        my = (y1 + y2) / 2;
      txt(
        g,
        x1 === x2 ? mx + (side || 8) : mx,
        x1 === x2 ? my : my - 7,
        '#d9c8a6',
        12,
        x1 === x2 ? 'start' : 'middle',
        label
      );
    }
    function renderViz(o) {
      const svg = $('[data-viz]');
      svg.innerHTML =
        '<defs>' +
        '<linearGradient id="' +
        ('pps-shade-' + SID) +
        '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e7c684"/><stop offset="1" stop-color="#a9802f"/></linearGradient>' +
        '<radialGradient id="' +
        ('pps-bulb-' + SID) +
        '"><stop offset="0" stop-color="#fff6df"/><stop offset=".5" stop-color="#ffd489"/><stop offset="1" stop-color="rgba(255,212,137,0)"/></radialGradient>' +
        '<linearGradient id="' +
        ('pps-cone-' + SID) +
        '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="rgba(255,212,137,.55)"/><stop offset="1" stop-color="rgba(255,212,137,0)"/></linearGradient>' +
        '<linearGradient id="' +
        ('pps-floor-' + SID) +
        '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2a2218"/><stop offset="1" stop-color="#171209"/></linearGradient></defs>';
      const g = el('g', {});
      svg.appendChild(g);
      g.appendChild(
        el('line', { x1: 60, y1: 40, x2: 740, y2: 40, stroke: '#4a3d2b', 'stroke-width': 3 })
      );
      txt(g, 60, 30, '#8E8472', 11, 'start', 'CEILING');
      if (o.feature) {
        const floorY = 380;
        g.appendChild(
          el('line', {
            x1: 60,
            y1: floorY,
            x2: 740,
            y2: floorY,
            stroke: 'url(#' + ('pps-floor-' + SID) + ')',
            'stroke-width': 6
          })
        );
        const cx = 400,
          clrPx = Math.min(250, (o.clearance / state.ceiling) * 300 + 60),
          botY = floorY - clrPx;
        if (o.cluster) {
          [-70, 0, 70].forEach((dx, i) =>
            pendant(
              g,
              cx + dx,
              40,
              botY - (i === 1 ? 40 : 0),
              o.featureDiameter,
              i % 2 ? 'b' : 'c',
              -i
            )
          );
        } else pendant(g, cx, 40, botY, o.featureDiameter, 'b', 0);
        dim(g, cx + 150, floorY, cx + 150, botY, o.clearance + 'mm clear', 10);
        txt(
          g,
          cx,
          floorY + 24,
          '#9b8a6c',
          12,
          'middle',
          o.cluster
            ? 'Cascading cluster — high ceiling'
            : 'Feature pendant ≈ ' + o.featureDiameter + 'mm Ø'
        );
        return;
      }
      const L = state.surfaceLength,
        sx = Math.min(0.3, 560 / Math.max(L, 900)),
        surfPx = L * sx,
        x0 = 400 - surfPx / 2,
        x1 = 400 + surfPx / 2,
        surfH = 18;
      const ceilY = 40,
        floorBaseY = 398,
        vScale = (floorBaseY - ceilY) / Math.max(state.ceiling, 2200);
      const surfY = Math.round(floorBaseY - o.surfaceHeight * vScale);
      const hp = Math.max(32, o.hangMid * vScale),
        botY = Math.round(surfY - hp);
      // floor + ceiling-driven drop caption (top-right) so the ceiling slider visibly changes the scene
      g.appendChild(
        el('line', {
          x1: 60,
          y1: floorBaseY,
          x2: 740,
          y2: floorBaseY,
          stroke: '#2a2218',
          'stroke-width': 4
        })
      );
      txt(g, 740, 30, '#9b8a6c', 11, 'end', 'drop from ceiling: ' + o.dropFromCeiling + 'mm');
      g.appendChild(
        el('rect', {
          x: x0,
          y: surfY,
          width: surfPx,
          height: surfH,
          rx: 4,
          fill: 'url(#' + ('pps-floor-' + SID) + ')',
          stroke: '#4a3d2b',
          'stroke-width': 1.5
        })
      );
      txt(
        g,
        400,
        surfY + surfH + 20,
        '#9b8a6c',
        12,
        'middle',
        ROOMS[state.room].surfaceLabel + ': ' + L + 'mm'
      );
      if (o.linear) {
        const lw = Math.min(surfPx * 0.9, o.widthMax * sx),
          lx0 = 400 - lw / 2,
          grp = el('g', { class: 'sway b' });
        grp.appendChild(
          el('line', {
            x1: 400,
            y1: ceilY,
            x2: 400,
            y2: botY - 10,
            stroke: '#6f6049',
            'stroke-width': 1.4
          })
        );
        grp.appendChild(
          el('rect', {
            x: lx0,
            y: botY - 10,
            width: lw,
            height: 12,
            rx: 5,
            fill: 'url(#' + ('pps-shade-' + SID) + ')',
            stroke: '#3a2f1f'
          })
        );
        grp.appendChild(
          el('path', {
            d:
              'M' +
              lx0 +
              ' ' +
              (botY + 2) +
              ' L' +
              (lx0 - 20) +
              ' ' +
              surfY +
              ' L' +
              (lx0 + lw + 20) +
              ' ' +
              surfY +
              ' L' +
              (lx0 + lw) +
              ' ' +
              (botY + 2) +
              ' Z',
            fill: 'url(#' + ('pps-cone-' + SID) + ')',
            opacity: 0.5
          })
        );
        g.appendChild(grp);
        dim(g, lx0, botY + 26, lx0 + lw, botY + 26, o.widthMin + '–' + o.widthMax + 'mm');
      } else {
        o.positions.forEach((p, i) => {
          const px = x0 + p * sx;
          pendant(g, px, ceilY, botY, o.eachDiameter || 300, i % 2 ? 'b' : 'c', -i * 0.6);
        });
        if (o.positions.length > 1) {
          const fx0 = x0 + o.positions[0] * sx,
            fx1 = x0 + o.positions[o.positions.length - 1] * sx;
          dim(g, fx0, botY - 40, fx1, botY - 40, o.spacing + 'mm × ' + (o.count - 1));
        }
        dim(
          g,
          x0,
          surfY + surfH + 38,
          x1,
          surfY + surfH + 38,
          'span ' + (o.widthMin ? o.widthMin + '–' + o.widthMax + 'mm' : o.eachDiameter + 'mm')
        );
      }
      dim(g, x1 + 34, surfY, x1 + 34, botY, o.hang[0] + '–' + o.hang[1] + 'mm', 8);
      if (state.room === 'bedside')
        txt(g, 400, 30, '#d9c8a6', 12, 'middle', 'One pendant each side of the bed');
    }

    /* ---------- GUIDES ---------- */
    function renderGuides() {
      const r = ROOMS[state.room];
      $('[data-gheight]').innerHTML =
        '<line x1="10" y1="18" x2="250" y2="18" stroke="#4a3d2b" stroke-width="3"/><line x1="130" y1="18" x2="130" y2="58" stroke="#6f6049"/><path d="M118 58 l-6 14 h36 l-6 -14z" fill="#caa14d"/><circle cx="130" cy="74" r="5" fill="#ffd489"/><rect x="40" y="98" width="180" height="12" rx="3" fill="#241d12" stroke="#4a3d2b"/><line x1="200" y1="74" x2="200" y2="98" stroke="#9b8a6c" stroke-dasharray="1 3"/><text x="206" y="90" fill="#d9c8a6" font-size="11" font-family="Inter">' +
        (r.hang ? r.hang[0] + '–' + r.hang[1] + 'mm' : '2100mm+') +
        '</text>';
      $('[data-gwidth]').innerHTML =
        '<rect x="40" y="80" width="180" height="12" rx="3" fill="#241d12" stroke="#4a3d2b"/><line x1="40" y1="100" x2="220" y2="100" stroke="#9b8a6c" stroke-dasharray="1 3"/><text x="130" y="114" fill="#8E8472" font-size="10" font-family="Inter" text-anchor="middle">surface width</text><rect x="85" y="30" width="90" height="10" rx="4" fill="#caa14d"/><line x1="85" y1="22" x2="175" y2="22" stroke="#d9c8a6"/><text x="130" y="16" fill="#d9c8a6" font-size="11" font-family="Inter" text-anchor="middle">½–⅔ width</text>';
      const o = compute(),
        n = o.count && !o.feature ? o.count : 3;
      let dots = '';
      const span = 180,
        start = 40;
      for (let i = 0; i < n; i++) {
        const x = start + ((i + 0.5) * span) / n;
        dots +=
          '<line x1="' +
          x +
          '" y1="20" x2="' +
          x +
          '" y2="44" stroke="#6f6049"/><path d="M' +
          (x - 9) +
          ' 44 l4 12 h10 l4 -12z" fill="#caa14d"/><circle cx="' +
          x +
          '" cy="60" r="4" fill="#ffd489"/>';
      }
      $('[data-gspace]').innerHTML =
        '<line x1="10" y1="20" x2="250" y2="20" stroke="#4a3d2b" stroke-width="3"/>' +
        dots +
        '<rect x="40" y="92" width="180" height="12" rx="3" fill="#241d12" stroke="#4a3d2b"/><text x="130" y="84" fill="#d9c8a6" font-size="11" font-family="Inter" text-anchor="middle">' +
        n +
        ' equal divisions</text>';
    }

    /* ---------- MASTER RENDER ---------- */
    function render() {
      lastOut = compute();
      renderResults(lastOut);
      renderViz(lastOut);
      renderGuides();
    }

    /* ---------- STOREFRONT API + LIVE GRID ---------- */
    function parseDims(tags) {
      const out = [];
      (tags || []).forEach((t) => {
        const m = /^(Diameter|Width|Length|Height|Depth)_[ø]?(\d{2,5})mm$/i.exec(t);
        if (m) out.push({ k: m[1].toLowerCase(), v: +m[2] });
      });
      return out;
    }
    function widthOf(tags) {
      const d = parseDims(tags);
      const dia = d.find((x) => x.k === 'diameter');
      if (dia) return dia.v;
      const w = d.find((x) => x.k === 'width');
      if (w) return w.v;
      const l = d.find((x) => x.k === 'length');
      return l ? l.v : null;
    }
    // metafield helpers — values arrive as JSON arrays of strings, e.g. ["Black","White"] or ["330"]
    function mfArr(p, alias) {
      const m = p && p[alias];
      if (!m || !m.value) return [];
      let a;
      try {
        a = JSON.parse(m.value);
      } catch (e) {
        a = [m.value];
      }
      if (!Array.isArray(a)) a = [a];
      return a.map((s) => String(s).trim().toLowerCase());
    }
    function mfNums(p, alias) {
      return mfArr(p, alias)
        .map((s) => parseInt(s.replace(/[^0-9]/g, ''), 10))
        .filter((n) => n > 0);
    }
    function prodWidths(p) {
      const w = mfNums(p, 'mfWidth');
      if (w.length) return w;
      const t = widthOf(p.tags);
      return t ? [t] : [];
    }
    function prodHeights(p) {
      return mfNums(p, 'mfHeight');
    }
    function mfMatch(p, alias, val) {
      return !val || mfArr(p, alias).indexOf(String(val).trim().toLowerCase()) > -1;
    }
    function roomMatch(p) {
      const want = ROOM_MF[shopState.room] || [];
      if (!want.length) return true;
      const have = mfArr(p, 'mfRoom');
      return have.length ? have.some((v) => want.indexOf(v) > -1) : true;
    }
    function buildQuery(tagList) {
      const parts = [
        "(product_type:'Pendant Light' OR tag:'Pendant Light')",
        'available_for_sale:true'
      ];
      tagList.filter(Boolean).forEach((t) => {
        if (t === '__single') {
          parts.push("NOT tag:'Size_Linear'");
          parts.push("NOT tag:'linear_pendant'");
          parts.push("NOT tag:'Size_Multiple'");
        } else parts.push("tag:'" + t.replace(/'/g, '') + "'");
      });
      return parts.join(' AND ');
    }

    async function sfFetch(query, after) {
      if (!CFG.token) {
        return { error: 'no-token' };
      }
      const af = after ? ', after: "' + after + '"' : '';
      const gql =
        '{ products(first: 100, query: "' +
        query.replace(/"/g, '\\"') +
        '"' +
        af +
        ') { pageInfo { hasNextPage endCursor } edges { node { title handle availableForSale onlineStoreUrl vendor tags featuredImage { url } priceRange { minVariantPrice { amount currencyCode } } mfRoom: metafield(namespace:"filter",key:"room"){value} mfStyle: metafield(namespace:"filter",key:"style"){value} mfColour: metafield(namespace:"filter",key:"colour"){value} mfMaterial: metafield(namespace:"filter",key:"material"){value} mfWidth: metafield(namespace:"filter",key:"width"){value} mfHeight: metafield(namespace:"filter",key:"height"){value} } } } }';
      try {
        const res = await fetch(
          'https://' + CFG.shop + '/api/' + CFG.apiVersion + '/graphql.json',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': CFG.token
            },
            body: JSON.stringify({ query: gql })
          }
        );
        const j = await res.json();
        if (j.errors) {
          return { error: 'gql', detail: j.errors };
        }
        return {
          products: (j.data.products.edges || []).map((e) => e.node),
          pageInfo: j.data.products.pageInfo
        };
      } catch (e) {
        return { error: 'net', detail: String(e) };
      }
    }

    function skeletons() {
      let s = '';
      for (let i = 0; i < 8; i++)
        s +=
          '<div class="skel"><div class="imgwrap"></div><div class="pinfo"><div class="ln" style="width:80%"></div><div class="ln" style="width:50%"></div><div class="ln" style="width:35%"></div></div></div>';
      $('[data-grid]').innerHTML = s;
    }
    function fallbackLink() {
      // No token configured: deep-link into the theme's product search so the page still works.
      const t = shopState.type === '__single' ? '' : shopState.type;
      const terms = [
        ROOMS[shopState.room].roomTag,
        t,
        shopState.style,
        shopState.colour,
        shopState.material
      ].filter(Boolean);
      return (
        (CFG.storeUrl || window.location.origin) +
        '/search?type=product&q=' +
        encodeURIComponent(terms.join(' '))
      );
    }
    function card(p) {
      const w = prodWidths(p)[0] || null;
      const base = (CFG.storeUrl || window.location.origin).replace(/\/+$/, '');
      const url = base + '/products/' + p.handle;
      const price =
        p.priceRange && p.priceRange.minVariantPrice
          ? fmt.format(+p.priceRange.minVariantPrice.amount)
          : '';
      const img = p.featuredImage ? p.featuredImage.url : '';
      return (
        '<a class="pcard" target="_blank" rel="noopener" href="' +
        url +
        '"><div class="imgwrap">' +
        (img
          ? '<img loading="lazy" src="' + img + '" alt="' + p.title.replace(/"/g, '') + '">'
          : '') +
        '</div>' +
        '<div class="pinfo">' +
        (p.availableForSale ? '' : '<span class="badge-oos">Made to order</span>') +
        '<div class="ptitle">' +
        p.title +
        '</div>' +
        (p.vendor ? '<div class="pmeta">' + p.vendor + '</div>' : '') +
        (w ? '<div class="pdim">' + w + 'mm wide</div>' : '') +
        '<div class="pprice">' +
        (price ? 'from ' + price : '') +
        '</div></div></a>'
      );
    }

    let gridState = {
      query: '',
      cursor: null,
      hasNext: false,
      shown: [],
      seen: {},
      dropped: false,
      seq: 0
    };

    function appendProducts(prods, isFirst) {
      const grid = $('[data-grid]'),
        lm = $('[data-loadmore-wrap]'),
        countEl = $('[data-shopcount]');
      let add = prods.filter((p) => {
        if (!roomMatch(p)) return false;
        if (!mfMatch(p, 'mfStyle', shopState.style)) return false;
        if (!mfMatch(p, 'mfColour', shopState.colour)) return false;
        if (!mfMatch(p, 'mfMaterial', shopState.material)) return false;
        if (shopState.matchSize && shopState.band) {
          const ws = prodWidths(p);
          if (
            !ws.length ||
            !ws.some((w) => w >= shopState.band[0] * 0.85 && w <= shopState.band[1] * 1.15)
          )
            return false;
          if (shopState.maxHeight) {
            const hs = prodHeights(p);
            if (hs.length && Math.min.apply(null, hs) > shopState.maxHeight * 1.5) return false;
          }
        }
        return true;
      });
      add = add.filter((p) =>
        gridState.seen[p.handle] ? false : (gridState.seen[p.handle] = true)
      );
      add.forEach((p) => {
        p._idx = gridState.seq++;
      });
      gridState.shown = gridState.shown.concat(add);
      if (PRIORITY.length)
        gridState.shown.sort((a, b) => {
          const ra = brandRank(a.vendor),
            rb = brandRank(b.vendor);
          return ra !== rb ? ra - rb : a._idx - b._idx;
        });
      if (!gridState.shown.length) {
        if (gridState.hasNext) {
          countEl.textContent = 'Finding pendants…';
          lm.style.display = 'none';
          return;
        }
        grid.innerHTML =
          '<div class="empty">No live matches found. <a target="_blank" rel="noopener" href="' +
          fallbackLink() +
          '">Browse all pendants →</a></div>';
        lm.style.display = 'none';
        countEl.textContent = '';
        return;
      }
      grid.innerHTML = gridState.shown.map(card).join('');
      lm.style.display = gridState.hasNext ? '' : 'none';
      let msg =
        gridState.shown.length +
        (gridState.hasNext ? '+' : '') +
        ' ' +
        ROOMS[shopState.room].label.toLowerCase() +
        ' pendant' +
        (gridState.shown.length === 1 ? '' : 's');
      if (shopState.matchSize && shopState.band)
        msg += ' · sized ' + shopState.band[0] + '–' + shopState.band[1] + 'mm';
      countEl.textContent = msg;
    }

    async function loadGrid() {
      const grid = $('[data-grid]'),
        countEl = $('[data-shopcount]');
      skeletons();
      countEl.textContent = 'Finding pendants…';
      $('[data-loadmore-wrap]').style.display = 'none';
      const query = buildQuery([shopState.type]); // type via tag; room/style/colour/material/size all filtered client-side on metafields
      let r = await sfFetch(query);
      if (r.error === 'no-token') {
        grid.innerHTML =
          '<div class="empty">Live product matching isn’t configured yet.<br><a target="_blank" rel="noopener" href="' +
          fallbackLink() +
          '">Browse matching pendants →</a><br><small>(Add a Storefront API token in the theme editor to show product cards here.)</small></div>';
        countEl.textContent = '';
        return;
      }
      if (r.error) {
        grid.innerHTML =
          '<div class="empty">Couldn’t load products right now. <a target="_blank" rel="noopener" href="' +
          fallbackLink() +
          '">Browse matching pendants →</a></div>';
        countEl.textContent = '';
        return;
      }
      gridState = {
        query: query,
        cursor: r.pageInfo ? r.pageInfo.endCursor : null,
        hasNext: r.pageInfo ? r.pageInfo.hasNextPage : false,
        shown: [],
        seen: {},
        dropped: false,
        seq: 0
      };
      appendProducts(r.products || [], true);
      // metafield filters are applied client-side, so keep paging until the first screen is full
      let guard = 0;
      while (gridState.shown.length < CFG.per && gridState.hasNext && guard < 10) {
        guard++;
        const rr = await sfFetch(gridState.query, gridState.cursor);
        if (rr.error) break;
        gridState.cursor = rr.pageInfo ? rr.pageInfo.endCursor : null;
        gridState.hasNext = rr.pageInfo ? rr.pageInfo.hasNextPage : false;
        appendProducts(rr.products || [], false);
      }
    }

    async function loadMore() {
      if (!gridState.hasNext || !gridState.cursor) return;
      const btn = $('[data-loadmore]');
      btn.disabled = true;
      btn.textContent = 'Loading…';
      const r = await sfFetch(gridState.query, gridState.cursor);
      btn.disabled = false;
      btn.textContent = 'Load more pendants';
      if (r.error) return;
      gridState.cursor = r.pageInfo ? r.pageInfo.endCursor : null;
      gridState.hasNext = r.pageInfo ? r.pageInfo.hasNextPage : false;
      appendProducts(r.products || [], false);
    }
    $('[data-loadmore]').addEventListener('click', loadMore);
    // Force product/browse clicks to open a NEW tab even if the theme intercepts internal links.
    // Capture phase + stopPropagation beats any theme click handler, and window.open keeps the studio tab (with the customer's selections) open.
    $('[data-grid]').addEventListener(
      'click',
      function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let native modifier-clicks behave
        const a = e.target.closest('a');
        if (a && a.href) {
          e.preventDefault();
          e.stopPropagation();
          const w = window.open(a.href, '_blank');
          if (w) w.opener = null;
        }
      },
      true
    );

    /* ---------- FILTER UI ---------- */
    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }
    function chipBtn(fg, v, label) {
      return (
        '<button class="chip-f" data-fg="' +
        fg +
        '" data-v="' +
        esc(v) +
        '">' +
        esc(label != null ? label : v) +
        '</button>'
      );
    }
    function buildFilters() {
      const host = $('[data-filters]');
      let html = '';
      html +=
        '<div class="fgroup"><span class="flabel">Room</span><div class="fchips">' +
        Object.entries(ROOMS)
          .map(([k, r]) =>
            chipBtn(
              'room',
              k,
              r.label.replace(' / High Ceiling', '').replace('Commercial / Cafe', 'Cafe')
            )
          )
          .join('') +
        '</div></div>';
      html +=
        '<div class="fgroup"><span class="flabel">' +
        TYPEF.label +
        '</span><div class="fchips">' +
        TYPEF.opts.map((o) => chipBtn('type', o[1], o[0])).join('') +
        '</div></div>';
      Object.entries(MF).forEach(([key, f]) => {
        const long = f.opts.length > 8;
        html +=
          '<div class="fgroup' +
          (long ? ' collapsed' : '') +
          '"><span class="flabel">' +
          f.label +
          '</span><div class="fchips">' +
          f.opts.map((v) => chipBtn(key, v)).join('') +
          '</div>' +
          (long ? '<button class="fmore" type="button">+ more</button>' : '') +
          '</div>';
      });
      host.innerHTML = html;
      host.querySelectorAll('.chip-f').forEach((b) =>
        b.addEventListener('click', () => {
          const fg = b.dataset.fg,
            v = b.dataset.v;
          if (fg === 'room') {
            shopState.room = v;
            host
              .querySelectorAll('[data-fg=room]')
              .forEach((x) => x.classList.toggle('on', x.dataset.v === v));
          } else {
            const on = !b.classList.contains('on');
            host.querySelectorAll('[data-fg=' + fg + ']').forEach((x) => x.classList.remove('on'));
            if (on) {
              b.classList.add('on');
              shopState[fg] = v;
            } else shopState[fg] = '';
          }
          loadGrid();
        })
      );
      host.querySelectorAll('.fmore').forEach((b) =>
        b.addEventListener('click', () => {
          const g = b.closest('.fgroup');
          const collapsed = g.classList.toggle('collapsed');
          b.textContent = collapsed ? '+ more' : '− less';
        })
      );
      syncFilterUI();
    }
    function syncFilterUI() {
      const host = $('[data-filters]');
      if (!host) return;
      host
        .querySelectorAll('[data-fg=room]')
        .forEach((x) => x.classList.toggle('on', x.dataset.v === shopState.room));
      ['type', 'style', 'colour', 'material'].forEach((fg) =>
        host
          .querySelectorAll('[data-fg=' + fg + ']')
          .forEach((x) =>
            x.classList.toggle('on', x.dataset.v === shopState[fg] && !!shopState[fg])
          )
      );
    }
    $('[data-sizetoggle]').addEventListener('click', () => {
      shopState.matchSize = !shopState.matchSize;
      $('[data-sizetoggle] .switch').classList.toggle('on', shopState.matchSize);
      loadGrid();
    });

    // Calculator "Show pendants that fit" -> set shop room+band, enable size match, scroll, load
    $('[data-shopfit]').addEventListener('click', () => {
      shopState.room = state.room;
      shopState.type = cfgToType(state.config);
      shopState.band = lastOut ? lastOut.band : null;
      shopState.maxHeight = lastOut ? lastOut.maxHeight : null;
      shopState.matchSize = true;
      $('[data-sizetoggle] .switch').classList.add('on');
      $('[data-sizeband]').textContent =
        lastOut && lastOut.band ? '(' + lastOut.band[0] + '–' + lastOut.band[1] + 'mm)' : '';
      syncFilterUI();
      $('#pps-shop-' + SID).scrollIntoView({ behavior: 'smooth' });
      loadGrid();
    });

    /* ---------- QUIZ ---------- */
    const ans = {};
    let qi = 0;
    const stepsHost = $('[data-quizsteps]');
    QUIZ.forEach((s, idx) => {
      const d = document.createElement('div');
      d.className = 'qstep' + (idx === 0 ? ' on' : '');
      d.dataset.i = idx;
      d.innerHTML =
        '<span class="qcount">' +
        s.count +
        '</span><h3>' +
        s.q +
        '</h3><div class="opts">' +
        s.opts
          .map(
            (o) =>
              '<button class="opt" data-v="' +
              o[1] +
              '"><span class="ot">' +
              o[0] +
              '</span>' +
              (o[2] ? '<span class="od">' + o[2] + '</span>' : '') +
              '</button>'
          )
          .join('') +
        '</div><div class="qnav"><button class="qback">' +
        (idx > 0 ? '← Back' : '') +
        '</button><span></span></div>';
      stepsHost.appendChild(d);
      d.querySelectorAll('.opt').forEach((b) =>
        b.addEventListener('click', () => {
          ans[s.key] = b.dataset.v;
          next();
        })
      );
      d.querySelector('.qback').addEventListener('click', () => {
        if (qi > 0) {
          qi--;
          showStep();
        }
      });
    });
    function showStep() {
      $$('.qstep').forEach((s) => s.classList.toggle('on', +s.dataset.i === qi));
      $('[data-quizresult]').classList.remove('on');
      $('[data-qfill]').style.width = (qi / QUIZ.length) * 100 + '%';
    }
    function next() {
      if (qi < QUIZ.length - 1) {
        qi++;
        showStep();
      } else finishQuiz();
    }
    function finishQuiz() {
      $('[data-qfill]').style.width = '100%';
      $$('.qstep').forEach((s) => s.classList.remove('on'));
      const roomName = (QUIZ[0].opts.find((o) => o[1] === ans.room) || [])[0] || 'your room';
      const styleName = (QUIZ[1].opts.find((o) => o[1] === ans.style) || [])[0] || '';
      $('[data-matchname]').textContent =
        (styleName ? styleName + ' ' : '') + roomName + ' pendants';
      $('[data-matchdesc]').textContent =
        'Based on a ' +
        (styleName || '').toLowerCase() +
        ' look for the ' +
        roomName.toLowerCase() +
        ' in your chosen finish. Here are the live matches from our range.';
      $('[data-quizresult]').classList.add('on');
      // wire result CTA to the live grid with the quiz answers as filters
      $('[data-matchcta]').onclick = () => {
        shopState.room = ans.room || 'island';
        shopState.type = cfgToType(ans.config);
        shopState.style = ans.style || '';
        shopState.colour = ans.colour || '';
        shopState.material = ans.material || '';
        shopState.matchSize = false;
        $('[data-sizetoggle] .switch').classList.remove('on');
        syncFilterUI();
        $('#pps-shop-' + SID).scrollIntoView({ behavior: 'smooth' });
        loadGrid();
      };
    }
    $('[data-quizrestart]').addEventListener('click', () => {
      qi = 0;
      for (const k in ans) delete ans[k];
      showStep();
    });

    /* ---------- FAQ ---------- */
    $('[data-faq]').innerHTML = FAQS.map(
      (f) =>
        '<div class="qa"><button aria-expanded="false">' +
        f[0] +
        '<span class="plus"></span></button><div class="ans"><p>' +
        f[1] +
        '</p></div></div>'
    ).join('');
    $$('[data-faq] .qa button').forEach((b) =>
      b.addEventListener('click', () => {
        const qa = b.parentElement,
          a = qa.querySelector('.ans'),
          open = qa.classList.toggle('open');
        b.setAttribute('aria-expanded', open);
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      })
    );

    /* ---------- HERO ART ---------- */
    $('[data-hero]').innerHTML =
      '<svg class="scene-svg" viewBox="0 0 460 430"><defs>' +
      '<radialGradient id="' +
      ('pps-hb-' + SID) +
      '"><stop offset="0" stop-color="#fff6df"/><stop offset=".5" stop-color="#ffd489"/><stop offset="1" stop-color="rgba(255,212,137,0)"/></radialGradient>' +
      '<linearGradient id="' +
      ('pps-hs-' + SID) +
      '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#eccd8a"/><stop offset="1" stop-color="#a9802f"/></linearGradient>' +
      '<linearGradient id="' +
      ('pps-hc-' + SID) +
      '" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="rgba(255,212,137,.45)"/><stop offset="1" stop-color="rgba(255,212,137,0)"/></linearGradient></defs>' +
      '<line x1="0" y1="34" x2="460" y2="34" stroke="#4a3d2b" stroke-width="3"/>' +
      [
        [120, '', 0, 150, 52],
        [230, 'b', -1.2, 120, 64],
        [340, 'c', -2.4, 170, 46]
      ]
        .map(
          (p) =>
            '<g class="sway ' +
            p[1] +
            '" style="animation-delay:' +
            p[2] +
            's"><line x1="' +
            p[0] +
            '" y1="34" x2="' +
            p[0] +
            '" y2="' +
            (p[3] - 22) +
            '" stroke="#6f6049" stroke-width="1.6"/><path d="M' +
            (p[0] - p[4] / 2) +
            ' ' +
            p[3] +
            ' L' +
            (p[0] - p[4] / 4) +
            ' ' +
            (p[3] - 26) +
            ' L' +
            (p[0] + p[4] / 4) +
            ' ' +
            (p[3] - 26) +
            ' L' +
            (p[0] + p[4] / 2) +
            ' ' +
            p[3] +
            ' Z" fill="url(#' +
            ('pps-hs-' + SID) +
            ')" stroke="#3a2f1f"/><circle cx="' +
            p[0] +
            '" cy="' +
            (p[3] + 4) +
            '" r="11" fill="url(#' +
            ('pps-hb-' + SID) +
            ')" class="flicker"/><path d="M' +
            (p[0] - p[4] * 0.55) +
            ' ' +
            p[3] +
            ' L' +
            (p[0] - p[4] * 1.7) +
            ' 420 L' +
            (p[0] + p[4] * 1.7) +
            ' 420 L' +
            (p[0] + p[4] * 0.55) +
            ' ' +
            p[3] +
            ' Z" fill="url(#' +
            ('pps-hc-' + SID) +
            ')" opacity=".6"/></g>'
        )
        .join('') +
      '<rect x="60" y="406" width="340" height="14" rx="5" fill="#241d12" stroke="#4a3d2b"/></svg>';

    /* ---------- REVEAL ---------- */
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12 }
    );
    $$('.reveal').forEach((r) => io.observe(r));

    /* ---------- INIT ---------- */
    buildFilters();
    selectRoom('island');
    loadGrid();
  }

  function boot() {
    document.querySelectorAll('[data-pps]').forEach(function (root) {
      var cfgNode = root.querySelector('script[type="application/json"][data-pps-cfg]');
      if (!cfgNode) return;
      try {
        initPendantStudio(root, JSON.parse(cfgNode.textContent));
      } catch (e) {
        console.error('Pendant Studio config parse failed', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  global.initPendantStudio = initPendantStudio;
})(typeof window !== 'undefined' ? window : this);
